import { Component, OnDestroy } from '@angular/core';
import {
    DataServiceError,
    EntityCollectionService,
    EntityServices
} from '@ngrx/data';
import { select, Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging';
import * as fromDataServices from '../../data-services';
import { combineLatest } from 'rxjs';
import { filter, takeWhile } from 'rxjs/operators';
import * as fromAuth from '../../auth/store';
import { RegistrationModel } from '../../data-services/registration';
import { StateService } from '@uirouter/core';
import * as fromUserSetting from '../../user-setting';
import * as fromShared from '../../shared';
import { getUserInfo } from '../../user-info/store/user.reducer';

@Component({
    selector: 'ef-registration-container',
    templateUrl: './registration-container.component.html',
    styleUrls: ['./registration-container.component.scss'],
    standalone: false
})
export class RegistrationContainerComponent implements OnDestroy {
    dataService: EntityCollectionService<fromDataServices.Registration.RegistrationModel>;
    public needsRegistration = false;
    private active = true;

    constructor(
        private log: LoggingService,
        public entityServices: EntityServices,
        private store: Store,
        private ss: StateService
    ) {
        this.dataService =
            entityServices.getEntityCollectionService<fromDataServices.Registration.RegistrationModel>(
                fromDataServices.Registration.entityName
            );
        this.dataService.clearCache();
        try {
            this.dataService
                .getByKey('')
                .pipe(takeWhile(() => this.active))
                .subscribe(
                    () => {},
                    (dataserviceerrorFn: () => DataServiceError) => {
                        this.log.verbose({
                            type: 'RegistrationContainerComponent',
                            err: dataserviceerrorFn()
                        });
                        this.ss.go('dashboard');
                    }
                );
        } catch (err) {
            this.log.verbose({
                type: 'RegistrationContainerComponent',
                err
            });
            this.ss.go('dashboard');
        }

        combineLatest([
            this.dataService.entities$,
            this.store.pipe(select(fromAuth.getAuth)),
            this.store.pipe(select(getUserInfo)),
            this.store.pipe(
                select(
                    fromUserSetting.getSettingBooleanValue('TemporaryPassword')
                )
            )
        ])
            .pipe(
                filter(([entities]) => entities.length > 0),
                takeWhile(() => this.active)
            )
            .subscribe(([entities, auth, userInfo, tempPw]) => {
                const registration = entities.find(
                    x => x.CustomerId === auth.CustomerID
                ) as RegistrationModel;
                this.needsRegistration =
                    registration?.NeedsRegistration ?? false;
                this.log.verbose({
                    type: 'RegistrationContainerComponent',
                    entities,
                    auth,
                    registration,
                    needsRegistration: this.needsRegistration
                });

                if (!this.needsRegistration) {
                    const initialRouteState =
                        fromShared.resolveInitialRouteStateName(
                            userInfo?.Initialroutename
                        );
                    if (initialRouteState) {
                        this.ss.go(initialRouteState, {}, { reload: true });
                        return;
                    }

                    if (tempPw === true) {
                        this.ss.go('change-password');
                    } else {
                        this.ss.go('dashboard');
                    }
                }
            });
    }

    ngOnDestroy(): void {
        this.active = false;
    }

    onSaveRegistration($event: {
        ProductCode: string;
        CustomerId: string;
        EIN: string;
    }) {
        this.log.verbose({
            type: 'RegistrationContainerComponent:onSaveRegistration',
            $event
        });
        this.dataService.update({ ...$event, id: $event.CustomerId });
    }
}
